"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdditionalCost = _interopRequireDefault(require("./AdditionalCost"));
var _QuoteResponseLine = _interopRequireDefault(require("./QuoteResponseLine"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The QuoteResponse model module.
 * @module model/QuoteResponse
 * @version 0.0.1
 */
var QuoteResponse = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>QuoteResponse</code>.
   * @alias module:model/QuoteResponse
   */
  function QuoteResponse() {
    _classCallCheck(this, QuoteResponse);
    QuoteResponse.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(QuoteResponse, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>QuoteResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/QuoteResponse} obj Optional instance to populate.
     * @return {module:model/QuoteResponse} The populated <code>QuoteResponse</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new QuoteResponse();
        if (data.hasOwnProperty('fob')) {
          obj['fob'] = _ApiClient["default"].convertToType(data['fob'], 'String');
        }
        if (data.hasOwnProperty('ref_no')) {
          obj['ref_no'] = _ApiClient["default"].convertToType(data['ref_no'], 'String');
        }
        if (data.hasOwnProperty('expiration_ts')) {
          obj['expiration_ts'] = _ApiClient["default"].convertToType(data['expiration_ts'], 'Date');
        }
        if (data.hasOwnProperty('comments')) {
          obj['comments'] = _ApiClient["default"].convertToType(data['comments'], 'String');
        }
        if (data.hasOwnProperty('order_minimum_cost')) {
          obj['order_minimum_cost'] = _ApiClient["default"].convertToType(data['order_minimum_cost'], 'Number');
        }
        if (data.hasOwnProperty('line_minimum_cost')) {
          obj['line_minimum_cost'] = _ApiClient["default"].convertToType(data['line_minimum_cost'], 'Number');
        }
        if (data.hasOwnProperty('lines')) {
          obj['lines'] = _ApiClient["default"].convertToType(data['lines'], [_QuoteResponseLine["default"]]);
        }
        if (data.hasOwnProperty('additional_costs')) {
          obj['additional_costs'] = _ApiClient["default"].convertToType(data['additional_costs'], [_AdditionalCost["default"]]);
        }
        if (data.hasOwnProperty('requirements_checked')) {
          obj['requirements_checked'] = _ApiClient["default"].convertToType(data['requirements_checked'], 'Boolean');
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {String} fob
 */
QuoteResponse.prototype['fob'] = undefined;

/**
 * @member {String} ref_no
 */
QuoteResponse.prototype['ref_no'] = undefined;

/**
 * @member {Date} expiration_ts
 */
QuoteResponse.prototype['expiration_ts'] = undefined;

/**
 * @member {String} comments
 */
QuoteResponse.prototype['comments'] = undefined;

/**
 * @member {Number} order_minimum_cost
 */
QuoteResponse.prototype['order_minimum_cost'] = undefined;

/**
 * @member {Number} line_minimum_cost
 */
QuoteResponse.prototype['line_minimum_cost'] = undefined;

/**
 * @member {Array.<module:model/QuoteResponseLine>} lines
 */
QuoteResponse.prototype['lines'] = undefined;

/**
 * @member {Array.<module:model/AdditionalCost>} additional_costs
 */
QuoteResponse.prototype['additional_costs'] = undefined;

/**
 * @member {Boolean} requirements_checked
 */
QuoteResponse.prototype['requirements_checked'] = undefined;
var _default = exports["default"] = QuoteResponse;